module.exports = __webpack_public_path__ + "static/media/1012953.b77e016b.jpg";